import * as links from '../../../constants/links';
import {USER_TYPE_ADMIN} from '../../../constants/userTypes';
import isFunction from "mn-utils/isFunction";
import * as permissions from "../../../constants/permissions";
import {
  LINK_ADMIN_PROMO_FEES, LINK_ADMIN_PAYOUT,
  LINK_ADMIN_STABLECOINS_WITHDRAW,
  LINK_ADMIN_STATEMENTS
} from "../../../constants/links";

const userType = USER_TYPE_ADMIN;

export default [
  [`^${links.LINK_ADMIN_TRANSACTION_COLLISION}/?$`, {
    title: 'Blockchain',
    main: require('../../../components/pages/Admin/Blockchain'),
    permissions: [
      permissions.PERMISSION_ADMIN_REFUNDS
    ],
  }],
  [`^/?failed-auctions/([^/]+):id$`, {
    title: 'FailedAuctions',
    main: require('../../../components/pages/Admin/FailedAuctions'),
  }],
  [`^/?status/?$`, {
    title: 'Status',
    main: require('../../../components/pages/Admin/Status'),
  }],
  [`^/?logs(/([^/]+):id)$`, {
    title: 'Logs',
    main: require('../../../components/pages/Admin/Logs'),
  }],
  [`^/?earned-money/?$`, {
    title: 'Earned money',
    main: require('../../../components/pages/Admin/EarnedMoney'),
    permissions: [
      permissions.PERMISSION_ADMIN_EARNED_MONEY
    ],
  }],
  [`^/?accounts/?$`, {
    title: 'Accounts',
    main: require('../../../components/pages/Admin/Accounts'),
    permissions: [
      permissions.PERMISSION_ADMIN_ACCOUNTS
    ],
  }],
  [`^/?accounts(/([^/]+):id)$`, {
    title: 'Account',
    main: require('../../../components/pages/Admin/Account'),
    permissions: [
      permissions.PERMISSION_ADMIN_ACCOUNTS
    ],
  }],
  [`^/?kyc/?$`, {
    title: 'Accounts pending KYC verification',
    main: require('../../../components/pages/Admin/AccountsKYC'),
  }],
  [`^/kyc(/([^/]+):id)$`, {
    title: 'Account KYC',
    main: require('../../../components/pages/Admin/Account/KYC'),
  }],
  [`^/?admin-mpos-credentials(/([^/]+):id)$`, {
    title: 'MPos credentials',
    main: require('../../../components/pages/Admin/MPosCredentials'),
  }],
  [`^/?admin-withdraws/?$`, {
    title: 'Withdraws',
    main: require('../../../components/pages/Admin/Withdraws'),
    permissions: [
      permissions.PERMISSION_ADMIN_WITHDRAWS
    ],
  }],
  [`^${links.PERMISSION_ADMIN_WITHDRAWS}/?$`, {
    title: 'Stablecoins Withdraws',
    main: require('../../../components/pages/Admin/WithdrawsStablecoin'),
    permissions: [
      permissions.PERMISSION_ADMIN_WITHDRAWS_STABLECOINS
    ],
  }],
  [`^/?ordered-terminals/?$`, {
    title: 'Ordered terminals',
    main: require('../../../components/pages/Admin/OrderedTerminals'),
    permissions: [
      permissions.PERMISSION_ADMIN_TERMINALS_ORDERED
    ],
  }],
  [`^/?admin-terminals/?$`, {
    title: 'Terminals',
    main: require('../../../components/pages/Admin/Terminals'),
    permissions: [
      permissions.PERMISSION_ADMIN_TERMINALS
    ],
  }],
  [`^/?commissions/?$`, {
    title: 'Commissions',
    main: require('../../../components/pages/Admin/Commissions'),
  }],
  [`^/?exchange-rates/?$`, {
    title: 'Exchange rates',
    main: require('../../../components/pages/Admin/ExchangeRates'),
  }],
  [`^/?exchange-orders/?$`, {
    title: 'Exchange orders',
    main: require('../../../components/pages/Admin/ExchangeOrders'),
  }],
  [`^/?exchange-deposits/?$`, {
    title: 'Exchange deposits',
    main: require('../../../components/pages/Admin/ExchangeDeposits'),
  }],
  [`^/?arbitrage-deposits/?$`, {
    title: 'Arbitrage deposits',
    main: require('../../../components/pages/Admin/ArbitrageDeposits'),
  }],
  [`^/?deposits-status/?$`, {
    title: 'Deposits status',
    main: require('../../../components/pages/Admin/DepositsStatus'),
  }],
  [`^/?auctions/?$`, {
    title: 'Auctions',
    main: require('../../../components/pages/Admin/Auctions'),
  }],
  [`^/?admin-transactions/?$`, {
    title: 'Transactions',
    main: require('../../../components/pages/Admin/Transactions'),
  }],
  [`^/?merchant-statistic/?$`, {
    title: 'Merchant statistic',
    main: require('../../../components/pages/Admin/MerchantStatistic'),
    permissions: [
      permissions.PERMISSION_ADMIN_STATISTIC
    ],
  }],
  [`^/?admin-settings/?$`, {
    title: 'Settings',
    main: require('../../../components/pages/Admin/Settings'),
    permissions: [
      permissions.PERMISSION_ADMIN_SETTINGS
    ],
  }],
  [`^/?admin-help/?$`, {
    title: 'Help',
    main: require('../../../components/pages/Admin/Help'),
    permissions: [
      permissions.PERMISSION_ADMIN_HELP
    ],
  }],

  [`^${links.LINK_ADMIN_PAYOUT}/([^/]+):id$`, {
    title: 'Payout',
    main: require('../../../components/pages/Admin/Payout'),
  }],
  [`^${links.LINK_ADMIN_PAYOUT_MERCHANT}/?$`, {
    title: 'Payout merchants',
    main: require('../../../components/pages/Admin/Payout/Merchant'),
    permissions: [
      permissions.PERMISSION_ADMIN_PAYOUT_MERCHANT
    ],
  }],
  [`^${links.LINK_ADMIN_PAYOUT_MERCHANT}/([^/]+):id/?$`, {
    title: 'Payout details',
    main: require('../../../components/pages/Admin/Payout/Details'),
    permissions: [
      permissions.PERMISSION_ADMIN_PAYOUT_MERCHANT
    ],
  }],
  [`^${links.LINK_ADMIN_PAYOUT_GROUPS}/?$`, {
    title: 'Payout | Groups',
    main: require('../../../components/pages/Admin/Payout/Groups'),
    permissions: [
      permissions.PERMISSION_ADMIN_PAYOUT_GROUPS
    ],
  }],

  [`^${links.LINK_ADMIN_PAYOUT_NIUM_GROUP_INFO}/([^/]+):id/?$`, {
    title: 'Payout | Nium groups | Group info',
    main: require('../../../components/pages/Admin/Payout/Nium/GroupInfo'),
    permissions: [
      permissions.PERMISSION_ADMIN_PAYOUT_GROUPS
    ],
  }],
  [`^${links.LINK_ADMIN_PAYOUT_NIUM_REMITTERS}/?$`, {
    title: 'Payout | Nium Remitters',
    main: require('../../../components/pages/Admin/Payout/Nium/Remitters'),
  }],
  [`^${links.LINK_ADMIN_PAYOUT_NIUM_TRANSACTION_ADD}/([^/]+):group_id/([^/]+):fiat_code/?$`, {
    title: 'Add Manual Nium Transaction',
    main: require('../../../components/pages/Admin/Payout/Nium/GroupInfo/AddManualTransaction'),
  }],
  [`^${links.LINK_ADMIN_PAYOUT_NIUM_REMITTERS}/([^/]+):id(/([^/]+):fiat_code)?$`, {
    title: 'Nium Remitter',
    main: require('../../../components/pages/Admin/Payout/Nium/Remitters/Edit'),
  }],

  [`^${links.LINK_ADMIN_PAYOUT}/?$`, {
    title: 'Payout',
    main: require('../../../components/pages/Admin/Payout/Verto'),
    permissions: [
      permissions.PERMISSION_ADMIN_PAYOUT_VERTO
    ],
  }],
  [`^${links.LINK_ADMIN_PAYOUT_VERTO_GROUP_INFO}/([^/]+):id/?$`, {
    title: 'Payout | Verto groups | Group info',
    main: require('../../../components/pages/Admin/Payout/Verto/GroupInfo'),
  }],
  [`^${links.LINK_ADMIN_PAYOUT_VERTO_TRANSACTION_ADD}/([^/]+):group_id/([^/]+):fiat_code/?$`, {
    title: 'Add Manual Verto Transaction',
    main: require('../../../components/pages/Admin/Payout/Verto/GroupInfo/AddManualTransaction'),
  }],
  [`^${links.LINK_ADMIN_PAYOUT_VERTO_MANUAL_UPDATE}/([^/]+):id/([^/]+):currency/([^/]+):amount/?$`, {
    title: 'Verto manual update',
    main: require('../../../components/pages/Admin/Payout/Verto/GroupInfo/ManualUpdate'),
  }],
  [`^${links.LINK_ADMIN_PROMO_FEES}/?$`, {
    title: 'Promo Fees',
    main: require('../../../components/pages/Admin/KlubcoinFees'),
  }],

  [`^${links.LINK_ADMIN_MERCHANT_REFUNDS}/?$`, {
    title: 'Refunds',
    main: require('../../../components/pages/Admin/Refunds'),
    permissions: [
      permissions.PERMISSION_ADMIN_REFUNDS
    ],
  }],

  [`^${links.LINK_ADMIN_FINERY}/?$`, {
    title: 'Finery',
    main: require('../../../components/pages/Admin/Finery'),
    permissions: [
      permissions.PERMISSION_ADMIN_FINERY
    ],
  }],
  [`^${links.LINK_ADMIN_STABLECOINS_WITHDRAW}/?$`, {
    title: 'Master Merchant',
    main: require('../../../components/pages/Admin/WithdrawsStablecoin')
  }],
  [`^${links.LINK_ADMIN_STATEMENTS}/?$`, {
    title: 'Master Merchant',
    main: require('../../../components/pages/Admin/Statements')
  }],
  [`^${links.LINK_ADMIN_STATISTIC}/?$`, {
    title: 'Statistic',
    main: require('../../../components/pages/Admin/Statistic')
  }],
  [`^${links.LINK_REFERRAL_ADMIN}/?$`, {
    title: 'Master Merchant',
    main: require('../../../components/pages/Admin/MasterMerchant')
  }],
].map(([url, data]) => [url, isFunction(data) ? data : {...data, userType}]);
